import {useCallback, useState} from 'react'
import type {CommitComment} from '../../types/commit-types'
import {ExistingCommitComments} from './ExistingCommitComments'
import {NewCommitComment} from './NewCommitComment'
import type {Commit} from '../../types/shared'

export function CommitComments({initialComments, commit}: {initialComments: CommitComment[]; commit: Commit}) {
  const [comments, setComments] = useState(initialComments)

  const addComment = useCallback(
    (comment: CommitComment) => {
      setComments([...comments, comment])
    },
    [comments],
  )

  return (
    <div>
      <ExistingCommitComments comments={comments} commit={commit} setComments={setComments} />
      <NewCommitComment commitOid={commit.oid} addComment={addComment} />
    </div>
  )
}

try{ CommitComments.displayName ||= 'CommitComments' } catch {}